// general imports
import { createAsyncThunk } from '@reduxjs/toolkit'
import { getExceptionPayload } from '../../../lib/utils/get-exception-payload'

import { ApiRequestErrorType } from '../../../types/api/api.types'

import { IndividualService } from '../../../services/api/super-admin/individual/individual.service'
import { IndividualAccountsRequestType } from '../../../types/individual.type'

const individualService = new IndividualService()

export const getIndividualAccountsThunk = createAsyncThunk(
  'auth/users/active-users',
  async (data: IndividualAccountsRequestType, { rejectWithValue }) => {
    try {
      const response = await individualService.getIndividualAccounts(data)

      return response?.data
    } catch (ex) {
      return rejectWithValue(getExceptionPayload(ex) as ApiRequestErrorType)
    }
  },
)
